import * as React from 'react';
interface ILock {
    style?: {}; // inline style obj
    color?: string; // #000000
}
const Lock: React.FC<ILock> = (props) => {
    const { color } = props;
    return (
        <svg 
            width="10" 
            height="13" 
            viewBox="0 0 10 13" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <path 
                fill-rule="evenodd" 
                clip-rule="evenodd" 
                d="M5 0C6.76731 0 8.2 1.43269 8.2 3.2V4.5H6.999L7 3.2C7 2.14564 6.18412 1.28183 5.14926 1.20549L5 1.2C3.94564 1.2 3.08183 2.01588 3.00549 3.05074L3 3.2V4.5H1.8V3.2C1.8 1.43269 3.23269 0 5 0ZM1.8 4.5V5.5H8.2V4.5H9C9.55229 4.5 10 4.94772 10 5.5V11.5C10 12.0523 9.55229 12.5 9 12.5H1C0.447715 12.5 0 12.0523 0 11.5V5.5C0 4.94772 0.447715 4.5 1 4.5H1.8ZM6.3 7.9C6.3 7.18203 5.71797 6.6 5 6.6C4.28203 6.6 3.7 7.18203 3.7 7.9C3.7 8.44153 4.03112 8.90573 4.50194 9.10118C4.50066 9.11726 4.5 9.13355 4.5 9.15V10.25L4.50806 10.3489C4.55039 10.6054 4.75454 10.8 5 10.8C5.27614 10.8 5.5 10.5538 5.5 10.25V9.15L5.49609 9.10199C5.96796 8.90703 6.3 8.44229 6.3 7.9Z" 
                fill={!!color ? `${color}` : "#999999"}
            />
        </svg>
    );
};

export default Lock;
